import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "league-section-teams" }
const _hoisted_2 = {
  key: 1,
  class: "table"
}
const _hoisted_3 = { class: "league-section-schedule" }
const _hoisted_4 = {
  key: 1,
  class: "table"
}
const _hoisted_5 = { class: "align-right fit-content" }
const _hoisted_6 = { class: "fit-content noprint noselect" }

import CardContainer from '@/components/common/CardContainer.vue'
import IfViewport from '@/components/common/IfViewport.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import {
  formatDate,
  formatFloat,
  formatTime,
  formatValue,
} from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueSections',
  setup(__props) {

const leagues = useLeaguesStore()

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leagues).selectedLeague?.sections ?? [], (section, i) => {
    return (_openBlock(), _createBlock(CardContainer, {
      key: `section-${i}`,
      title: _ctx.$t('leagues.labels.section', { section: section.number })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.teams')), 1),
          (section.teams.length === 0)
            ? (_openBlock(), _createBlock(NotificationBanner, {
                key: 0,
                message: _ctx.$t('leagues.errors.no-teams'),
                "is-warning": ""
              }, null, 8, ["message"]))
            : (_openBlock(), _createElementBlock("table", _hoisted_2, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.name')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.city')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.teams, (team, j) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `team-${i}-${j}`
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(team.name)), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(team.city)), 1)
                    ]))
                  }), 128))
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.schedule')), 1),
          (section.rounds.length === 0)
            ? (_openBlock(), _createBlock(NotificationBanner, {
                key: 0,
                message: _ctx.$t('leagues.errors.no-rounds'),
                "is-warning": ""
              }, null, 8, ["message"]))
            : (_openBlock(), _createElementBlock("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("th", { class: "align-right fit-content" }, "Round", -1)),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.date-time')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.bowling-alley')), 1),
                    _createVNode(IfViewport, { "min-width": "768" }, {
                      default: _withCtx(() => [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.city')), 1)
                      ]),
                      _: 1
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("th", { class: "fit-content" }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.rounds, (round, j) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `round-${i}-${j}`
                    }, [
                      _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(formatFloat)(round.number, 0)), 1),
                      _createElementVNode("td", null, [
                        _createVNode(IfViewport, { "min-width": "768" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formatDate)(new Date(round.start_time), true, true)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(IfViewport, { "max-width": "767" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formatDate)(new Date(round.start_time), false, true)) + " ", 1),
                            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(formatTime)(new Date(round.start_time))), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(_unref(formatValue)(round.bowling_alley_name)) + " ", 1),
                        _createVNode(IfViewport, { "max-width": "767" }, {
                          default: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_unref(formatValue)(round.city)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode(IfViewport, { "min-width": "768" }, {
                        default: _withCtx(() => [
                          _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(round.city)), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("td", _hoisted_6, [
                        _createVNode(_component_RouterLink, {
                          to: {
                  path: `/leagues/${_unref(leagues).selectedSeason}/${_unref(leagues).selectedLeague?.id}/standings/${round.id}`,
                }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("small", null, [
                              _createVNode(_component_FontAwesomeIcon, {
                                class: "icon",
                                icon: "file-contract"
                              }),
                              _createVNode(IfViewport, { "min-width": "768" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('leagues.labels.standings')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
        ])
      ]),
      _: 2
    }, 1032, ["title"]))
  }), 128))
}
}

})